//assets
import HouseSvg from 'assets/icons/buildings/houseSvg.svg';
import AnalyticsSvg from 'assets/icons/graphsAndData/analyticsSvg.svg';
import DashboardSvg from 'assets/icons/graphsAndData/dashboardSvg.svg';
import PeopleSvg from 'assets/icons/human/peopleSvg.svg';
import ChainSvg from 'assets/icons/itemsAndObjects/chainSvg.svg';
import SearchObject from 'assets/icons/itemsAndObjects/searchObject.svg';
import Invoice from 'assets/icons/office/file.svg';
import Kanban from 'assets/icons/office/kanban.svg';
import ListSvg from 'assets/icons/office/listSvg.svg';
import MessageNotificationSvg from 'assets/icons/office/messageNotificationSvg.svg';
import Discount from 'assets/icons/signsAndSymbols/discount.svg';
import ActivityLogSvg from 'assets/icons/time/activityLogSvg.svg';
import CalendarSvg from 'assets/icons/time/calendarSvg.svg';
//configs
import { claims } from 'configs/claims';
//helpers
import getAllowedRoutes from 'helper/routes/getAllowedRoutes';

export const getAccommodationsMainNavigation = userClaims => {
  return getAllowedRoutes(userClaims, [
    {
      label: 'Dashboard',
      path: '/accommodations/dashboard',
      icon: DashboardSvg,
      permission: [],
    },
    {
      label: 'Calendar',
      path: '/accommodations/calendar',
      icon: CalendarSvg,
      permission: [claims.ViewCalendar],
    },
    {
      label: 'Reservations',
      path: '/accommodations/reservations?tab=all',
      icon: ListSvg,
      permission: [claims.ViewReservation, claims.ViewBasicReservation, claims.ViewOccupancies],
    },
    {
      label: 'Search',
      path: '/accommodations/search',
      icon: SearchObject,
      permission: [claims.ViewAccomodationSearch],
    },
    {
      label: 'Partners',
      path: '/accommodations/partners',
      icon: PeopleSvg,
      permission: [claims.ViewPartners],
    },

    {
      label: 'Messages',
      path: '/accommodations/messages?messageType=unanswered',
      icon: MessageNotificationSvg,
      permission: [claims.ViewMessaging],
    },
    {
      label: 'Rentals',
      path: '/accommodations/rentals',
      icon: HouseSvg,
      permission: [claims.ViewObject],
    },
    {
      label: 'Invoices',
      path: '/accommodations/invoices',
      icon: Invoice,
      permission: [claims.ViewInvoices],
    },
    {
      label: 'Tasks',
      path: '/accommodations/tasks',
      icon: Kanban,
      permission: [claims.ViewTasks],
    },
    {
      label: 'Partner benefits',
      path: '/accommodations/partner-benefits',
      icon: Discount,
      permission: [claims.ViewPartnerBenefits],
    },
    {
      label: 'Integrations',
      path: '/accommodations/channel-manager/',
      icon: ChainSvg,
      permission: [claims.ViewChannelManagerBasic, claims.ViewCM],
    },
    {
      label: 'Analytics',
      path: '/accommodations/analytics',
      icon: AnalyticsSvg,
      permission: [claims.ViewAnalytics],
      disabled: true,
    },
    {
      label: 'Activity log',
      path: '/accommodations/activity-log',
      icon: ActivityLogSvg,
      permission: [claims.ViewActivity],
      disabled: true,
    },
  ]);
};
